module.exports = __webpack_public_path__ + "static/img/yytx09.283dcc6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx09.png
// module id = 881
// module chunks = 0